import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Upload, Modal, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons';

import { DEFAULT_IMAGE_URL } from '../../utils/contrains'

export default class PicturesBanner extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    state = {
        previewVisible: false,
        previewImage: '',
        fileList: []
    }

    // 來自上層組件的參數
    static propTypes = {
        images_source: PropTypes.array,
        api_url: PropTypes.string.isRequired
    }

    UNSAFE_componentWillMount() {
        // const { images_source } = this.props
        // const fileList = this.init_edit_images(images_source)
        // this.setState({ fileList })
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_edit_images = (images) => {
        //console.log('images', images)
        if (images) {
            return images.reduce((row_pre, row) => {
                row_pre.push({
                    uid: row.Uid,
                    name: row.FileNewName,
                    status: 'done',
                    url: DEFAULT_IMAGE_URL + row.FileUrl
                })
                return row_pre
            }, [])
        } else {
            return []
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = file => {
        this.setState({
            previewVisible: true,
            previewImage: file.url || file.thumUrl,
        })
    }

    /* file:為當前被操作的文件 */
    handleChange = async ({ file, fileList }) => {
        //console.log('handleChange()', file.status, fileList)
        if (file.status === 'uploading') {

        }
        else if (file.status === 'done') {
            const result = file.response
            //console.log(result)
            if (result.status === 'done') {
                //message.success("上傳圖檔成功")
                const { name, url, uid } = result
                file = fileList[fileList.length - 1]
                file.name = name
                file.url = url
                file.uid = uid
            } else {
                message.error("上傳圖檔失敗")
            }
        } else if (file.status === 'removed') {
            // console.log('removed()', file)
            // const fileName = file.uid + '.' + file.name.split(".").pop()
            // await delFile_LiveCase(fileName, memoryUtils.user.token)
        }

        this.setState({ fileList })
        //console.log('state:', this.state.fileList)
    }

    // 外部接收方法 ////////////////////////////////////   

    // 提供給父組件(product-modify)使用
    output_files = () => { return this.state.fileList.map(file => file.url) }

    /////////////////////////////////////////////////////////////

    render() {
        const { api_url } = this.props
        const { previewVisible, previewImage, fileList } = this.state
        const uploadButton = (
            <div>
                <PlusOutlined />
                <div>上傳</div>
            </div>
        )

        return (
            <div>
                <Upload
                    action={DEFAULT_IMAGE_URL + api_url}
                    name="file"  //請求參數名稱
                    accept="image/*"
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                    maxCount={4}
                >
                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="bigImage" style={{ width: '10px', height:'300px' }} src={previewImage} />
                </Modal>
            </div>
        )
    }

}